
/* eslint-disable @typescript-eslint/camelcase */
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { DispatchController } from "@/app/ui/controllers/DispatchController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { UpdateDispatchRequest } from "@/data/payload/api/DispatchApiRequest";
import { DispatchTemporary, UpdateDispatch, UpdateDispatchStt } from "@/domain/entities/Dispatch";
import { debounce } from "lodash";
import { Vue, Options, prop } from "vue-class-component";
import SummaryCard from "./components/summary-card.vue";
import {
  getDataLocalStorage,
  storeDatatoLocalStorage
} from "@/app/infrastructures/misc/Utils";
import ScanFailedCard from "@/app/ui/views/cargo/component/scan-failed-card/index.vue";
import { CargoScanFailed } from "@/domain/entities/Cargo";

class Props {
  scanData = prop<any[]>({
    default: [],
    type: Array
  });
  demStatus = prop<boolean>({
    default: false,
    type: Boolean
  });
  scanFailedList = prop<CargoScanFailed[]>({
    default: [],
    type: Array
  });
}

@Options({
  emits: ["scan"],
  components: {
    // Add your components here
    SummaryCard,
    ScanFailedCard
  },
})
export default class HeaderUpdate extends Vue.with(Props) {
  inputNo = ""
  isDuplicateScan = false
  errorScan = false
  errorType = ""
  errorMessageScan = ""
  isLoading = false
  clearScan = ""

  get shuttleId() {
    return AccountController.accountData.shuttleId;
  }

  get scanStatus() {
    return this.scanData[0]?.dtDemNo === this.scanData[0]?.dtScanNo
      ? this.scanData[0]?.dtDemStatus
      : this.scanData[0]?.dtScanStatus;
  }

  get successIllustration() {
    const isKonsolChecker = !this.shuttleId;
    let image = ""
    if (this.scanStatus === "success") {
      image = isKonsolChecker ? "kondispatch_success" : "stldispatch_success"
    } else if (this.scanStatus === "partial") {
      image = isKonsolChecker ? "kondispatch_partially" : "stldispatch_partially"
    } else {
      image = "dispatch_error"
    }
    return image
  }

  get errorIllustration() {
    let image = ""
    if (this.errorType === "server") {
      image = require(`@/app/ui/assets/svg/dispatch/dispatch_server_error.svg`)
    } else if (this.errorType === "internet") {
      image = require(`@/app/ui/assets/svg/dispatch/dispatch_internet_error.svg`)
    } else {
      image = require(`@/app/ui/assets/svg/dispatch/dispatch_error.svg`)
    }
    return image
  }

  get scanIllustration() {
    if (this.isDuplicateScan) {
      const image = !this.shuttleId ? "kondispatch_success" : "stldispatch_success"
      return require(`@/app/ui/assets/svg/dispatch/${image}.svg`)
    }
    return this.errorScan ? this.errorIllustration : require(`@/app/ui/assets/svg/dispatch/${this.successIllustration}.svg`)
  }

  get backgroundStyling() {
    if (this.isDuplicateScan) return "bg-green-lp-1300"
    return this.errorScan ? "bg-red-lp-1100" : this.scanStatus === "success" ? "bg-green-lp-1300" : this.scanStatus === "partial" ? "bg-yellow-lp-400" : "bg-red-lp-1100"
  }

  get scanMessage() {
    if (this.isDuplicateScan) return this.$t("STT Sudah Di Scan")
    if (this.errorScan) return this.errorMessageScan

    const isDem = this.scanData[0]?.dtDemNo === this.scanData[0]?.dtScanNo

    if (isDem) {
      if (this.scanStatus === "success") return this.$t("dispatch.scanMessageDemSuccess")
      if (this.scanStatus === "partial") return this.$t("dispatch.scanMessageDemPartial")
      if (this.scanStatus === "failed") return this.$t("dispatch.scanMessageDemFailed")
      return ""
    }

    if (this.scanStatus === "success") return this.$t("dispatch.scanMessageSttSuccess")
    if (this.scanStatus === "partial") return this.$t("dispatch.scanMessageSttPartial")
    if (this.scanStatus === "failed") return this.$t("dispatch.scanMessageSttFailed")
    if (this.scanStatus === "failed_unpaid") return this.$t("dispatch.scanMessageSttFailedUnpaid")
    if (this.scanStatus === "failed_destination") return this.$t("dispatch.scanMessageSttFailedDestination")
    if (this.scanStatus === "failed_IN-HUB") return this.$t("dispatch.scanMessageSttFailedInHub")

    return this.$t("dispatch.scanMessageSttFailedStatusMismatch", {
      lastStatus: this.scanData[0]?.sttLastStatusId
    })
  }

  onScan = debounce((val: string) => {
    const splitVal = val.split("#")[0];
    this.updateDispatch(splitVal)
  }, 500);

  successScannedData(res: UpdateDispatch) {
    const mapDispatchData = (source: UpdateDispatchStt) =>
      new DispatchTemporary({
        dtId: 0,
        dtAccountId: 0,
        dtIsActive: false,
        dtSttNo: source.sttNo,
        dtProductType: source.sttProductType,
        dtDestinationCityId: source.sttDestinationCityId,
        dtDestinationDistrictId: source.sttDestinationDistrictId,
        dtDestinationDistrictName: source.sttDestinationDistrictName,
        dtDestinationDistrictUrsaCode: source.sttDestinationDistrictUrsaCode,
        dtRefNo: source.refNo,
        dtDemNo: source.demNo,
        dtPieces: source.sttTotalPiece,
        dtChargeableWeight: source.sttGrossWeight,
        dtScanStatus: source.dtScanStatus,
        dtMeta: {},
        dtCreatedAt: source.dtCreatedAt,
        dtUpdatedAt: source.dtUpdatedAt,
        dtDemStatus: res.demStatus,
        dtScanNo: source.dtScanNo,
        sttLastStatusId: source.sttLastStatusId,
        dtRecipientName: source.sttRecipientName,
        dtRecipientPhone: source.sttRecipientPhone,
        dtRecipientAddress: source.sttRecipientAddress,
        dtDemTotal: res.dtDemTotal,
        dtDemTotalNow: res.dtDemTotalNow,

    });
    return res.dem.length > 0 ? res.dem.map(mapDispatchData) : [mapDispatchData(res.stt)]
  }

  handleError(error: any) {
    this.isDuplicateScan = false
    this.errorType = ""
    if (error?.response) {
      if (error.response?.status === 400) {
        this.isDuplicateScan = error.response.data.message.id === "Nomor Dem atau Stt pernah discan"
        this.errorMessageScan = error.response.data.message.id === "Nomor Dem atau Stt pernah discan"
          ? this.$t("dispatch.scanErrorAlreadyExists")
          : this.$t("dispatch.scanErrorInvalid")
      } else {
        this.errorType = "server"
        this.errorMessageScan = this.$t("dispatch.scanErrorServer")
      }
    } else {
        this.errorType = "internet"
        this.errorMessageScan = this.$t("dispatch.scanErrorInternet")
    }
  }

  async updateDispatch(scanNo: string) {
    if (this.isLoading) return
    this.isDuplicateScan = false
    try {
      MainAppController.showLoading();
      this.isLoading = true
      const res = await DispatchController.updateDispatch(new UpdateDispatchRequest(scanNo))
      storeDatatoLocalStorage("dispatch-summary", res);
      this.inputNo = ""
      this.$emit("scan", this.successScannedData(res));
      this.errorScan = false
      const status = res.dem?.length ? res.demStatus : res.stt.dtScanStatus;
      if (status.includes("failed")) {
        playNotification("error");
      } else {
        playNotification("success");
      }
    } catch(error) {
      this.handleError(error)
      playNotification(this.isDuplicateScan ? "duplicate" : "error");
      this.errorScan = true
      this.inputNo = scanNo
    } finally {
      MainAppController.closeLoading();
      this.isLoading = false
      this.clearScan = ""
    }
  }

  get scanNo() {
    return this.errorScan ? this.inputNo : this.scanData[0]?.dtScanNo
  }
  get demNo() {
    return this.scanData[0]?.dtDemNo
  }

  get valueSummary() {
    return this.scanData[0]?.dtDemNo
      ? this.scanData[0]?.dtDemNo
      : this.scanData[0]?.dtScanNo;
  }

  get SummarySummaryLocalStorage() {
    if(this.scanData[0]?.dtDemTotalNow) {
      return this.scanData[0];
    } else {
      const summaryData =
      (JSON.parse(
        getDataLocalStorage("dispatch-summary")
      ) as any) || [];
      return summaryData.length > 0 ? summaryData[0] : summaryData;
    }
  }

}
